import { getIsAQuoteTemplate } from 'Cube/domain/postActionStages/utils/getIsQuoteATemplate'
import {
  CubeReducerState,
  CubeStatus,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'
import { match } from 'ts-pattern'

export const getEditStartDateAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  if (getIsAQuoteTemplate(prevState)) {
    return {
      available: { visible: false, enabled: false },
      reasons: [
        {
          reasonType: DisabledReasonType.InvalidStatus,
          metadata: { status: prevState.data.common.status }
        }
      ]
    }
  }

  if (prevState.data.quote.dealType === 'AMENDMENT') {
    return {
      available: { visible: false, enabled: false },
      reasons: [
        {
          reasonType: DisabledReasonType.CantChangeOnAmendmentDealType,
          metadata: {}
        }
      ]
    }
  }

  const {
    common: { isArchived, status }
  } = prevState.data

  if (isArchived) {
    return {
      available: { visible: true, enabled: false },
      reasons: [
        { reasonType: DisabledReasonType.CantChangeWhenArchived, metadata: {} }
      ]
    }
  }

  if (prevState.data.quote.runningQuoteApprovalAutomationExecutionId) {
    return {
      available: { visible: true, enabled: false },
      reasons: [
        { reasonType: DisabledReasonType.PendingApproval, metadata: {} }
      ]
    }
  }

  if (
    status === CubeStatus.QuotePreparingSignatureRequest ||
    status === CubeStatus.QuoteExecuted
  ) {
    return {
      available: { visible: true, enabled: false },
      reasons: [
        {
          reasonType: match(status)
            .with(
              CubeStatus.QuotePreparingSignatureRequest,
              () => DisabledReasonType.CantChangeWhenPreparingSignatureRequest
            )
            .with(
              CubeStatus.QuoteExecuted,
              () => DisabledReasonType.CantChangeWhenExecuted
            )
            .exhaustive(),
          metadata: {}
        }
      ]
    }
  }

  return {
    available: {
      visible: true,
      enabled: true
    },
    reasons: []
  }
}
